import React, { useState } from "react";
import { CameraFilled } from "@ant-design/icons";
import { Form, Upload, Spin, Button } from "antd";

import { convertBase64 } from '../../utils/convertBase64';

interface props {
  form?: any
}

const PhotoUpload: React.FC<props> = (props) => {
  const { form } = props;
  const [selectedImage, setSelectedImage] = useState<any>()

  const handleRemoveImage = () => {
    setSelectedImage(undefined)
  }

  const handleImagechange = async (image?: any) => {
    let b64 = await convertBase64(image?.file)
    // setSelectedImage(image?.file)
    setSelectedImage(b64)
    form.setFieldValue("images", b64)
  }

  return (
    <div className="answer-input-wrapper image-upload">
      <Form.Item name="images">
        <Upload
          action=""
          listType="picture"
          maxCount={1}
          multiple={false}
          className="face-image-uploader"
          beforeUpload={() => false}
          iconRender={() => {
            return <Spin />;
          }}
          onChange={(image?: any) => {
            handleImagechange(image)
          }}
          itemRender={(existingComp, file) => {
            if (selectedImage) {
              return (
                <div className="initial-selection">
                  <img
                    src={selectedImage}
                    width={"250px"}
                    height={"250px"}
                    alt=""
                  />
                </div>
              );
            }
            return (<></>)
          }}
          onRemove={() => { console.log('on remove called') }}
        >
          {selectedImage ?
            <></>
            :
            <>
              <div className="initial-selection-area" >
                <CameraFilled className="icon" />
              </div>
              <Button className="image-button buttons__upload">
                Upload Photo
              </Button>
            </>
          }

        </Upload>
        <div className="buttons">
          {selectedImage ?
            <Button
              className="image-button buttons__remove"
              onClick={handleRemoveImage}
            >
              Remove Photo
            </Button>
            :
            <></>
          }
        </div>
      </Form.Item>
    </div>
  );
};

export default PhotoUpload;
